import React from 'react';
import { Button, Text } from '../../Atoms';
import { PhotoLoginOrganisme } from '../../Organisms';
import { useHistory } from 'react-router'; 
import KeycloakService from '../../Services/KeycloakService';
function TemplateResetPasswordMailStep2(props) {
  const history = useHistory();
  const faireRedirection = () => {
    KeycloakService.doLogin();
  };
  return (
    <div className="login-template">
      <div className="login-template-organism">
         <div className="login-container"> 
                   <Text
                   text="Bienvenue sur votre espace assuré !"
                   type="title-42"
                   className="login-welcome-text"
                 />
                 <div className='first-login-divider' />
                 <div>
                   <Text
                     text="Réinitalisation de votre mot de passe"
                     type="h4"
                     className="login-title-text"
                   />
                   <div
                     style={{
                       display: 'flex',
                       justifyContent: 'left',
                       alignItems: 'left'
                     }}
                   >
                     <Text
                       text="Un lien de réinitialisation vient d‘être envoyé à l’adresse mail liée à vote contrat. 
Il vous permettra de définir un nouveau mot de passe."
                       className="text-description-first-login"
                     />
                   </div>
            <div className="first-login-small-container">
              <div className="btn-connexion-first-login-container">
                <Button
                  text="Revenir à l’espace de connexion"
                  className="btn-next-first-login"
                  boxShadow
                   iconRight={true}
                  icon="FlecheSuivi"
                  onClick={faireRedirection}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
       <PhotoLoginOrganisme />
    </div>
  );
}

export default TemplateResetPasswordMailStep2;
